import { CasinoType } from 'modules/Casino/types/configuration';
import ganamosCloverGIF from './img/GanamosClover.gif';

// 20630
export const filteredSlotsGames = {
  crashGames: [
    // 701, 702, 704, 706, 708, 707, 709, 710, 705, 711
  ],
  liveCasino: [502],
};

const tabs = {
  crash: [701, 702, 704, 706, 708, 709, 710, 705, 711, 712],
  halloween: [709],
};

export function getTab(slotName: number) {
  const trueTab = Object.keys(tabs).reduce(
    (acc, tab) => (tabs[tab as keyof typeof tabs].findIndex(item => item === slotName) === -1 ? acc : [...acc, tab]),
    ['slotMachines'],
  );
  return trueTab;
}

export const staticGames = [
  {
    id: '249',
    gameId: 249,
    description: 'Ganamos Clover',
    provider: 'popokgaming',
    gameName: 'Ganamos Clover',
    routeProvider: 'popokgaming',
    tab: getTab(249),
    imageUrl: ganamosCloverGIF,
    type: CasinoType.slots,
  },
];
